import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import { submitDavinFoodsQuiz } from "../../redux/actions/index";

const FoodAllergensQuiz = ({ appData, submitQuiz }) => {
  const fullName = `${appData.firstName} ${appData.lastName}`;
  const quizName = "foodAllergensQuiz";
  const onboarding = appData.davinFoodsOnboarding;

  const initialData = {
    name: fullName,
    signature: fullName,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <p className="mb-2 text-center font-weight-bold">
          Please complete the Managing Food Allergens at Davin Foods quiz as
          part of your induction with Reynolds.
        </p>
      ),
    },
    information: {
      title:
        "1. Which foods must be labelled with food allergen information by law?",
      value: getVal("information"),
      type: "radio",
      radioOptions: [
        "Anything that contains food allergens except where the product is an allergen e.g. celery",
        "Only if the product is an allergen e.g. celery",
        "All foods",
        "None",
      ],
      mandatory: true,
    },
    recognised: {
      title: "2. How many food allergens are recognised by law?",
      value: getVal("recognised"),
      type: "radio",
      radioOptions: ["14", "4", "0", "10"],
      mandatory: true,
    },
    contains: {
      title:
        "3. Are you allowed to bring foods containing nuts, peanuts and sesame for your lunch?",
      value: getVal("contains"),
      type: "radio",
      radioOptions: ["No", "Maybe - if it is for a special occasion", "Yes"],
      mandatory: true,
    },
    spillage: {
      title: "4. In the event of spillage we must...",
      value: getVal("spillage"),
      type: "radio",
      radioOptions: [
        "Walk on and take no action",
        "Report it to our Supervisor and ensure it is cleaned up in good time using the correct equipment",
        "Clean up with tissues",
        "Inform someone later on in the day",
      ],
      mandatory: true,
    },
    equipment: {
      title: "5. What colour equipment is used to clean up allergen spillages?",
      value: getVal("equipment"),
      type: "radio",
      radioOptions: ["Blue", "Yellow", "Pink", "Green"],
      mandatory: true,
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const completed =
    onboarding[quizName] &&
    (onboarding[quizName].status === "Pass" ||
      onboarding[quizName].retries === 0);
  const redirectBack = () =>
    history.push("/profile/edit/davin-foods-onboarding");
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitQuiz(quizName, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };
  return (
    <>
      {completed ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={
            "Managing Food Allergens Induction at Davin Foods Quiz (PR903)"
          }
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"davinFoods"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
FoodAllergensQuiz.propTypes = {
  appData: any,
  submitQuiz: func,
};
const mapDispatchToProps = {
  submitQuiz: submitDavinFoodsQuiz,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(FoodAllergensQuiz);
